export const trackingEvents = {
  PAGE: {
    VIEWED: 'worker_strikes.page.viewed',
  },
}
